import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const HoldingClassTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item nk-tb-head tb-tnx-head">
        <th className="nk-tb-col text-center">
          <span>{t('Class')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('NominalValue')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('SharesNumber')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('NumerationOfShares')}</span>
        </th>
        <th className="nk-tb-col text-right">
          <span>{t('VotesForParticipation')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl text-center">
          <span>{t('Numeration')}</span>
        </th>
        <th className="nk-tb-col text-left">
          <span>{t('PreferredLiquidation')}</span>
        </th>
        <th className="nk-tb-col text-left">
          <span>{t('Antidilution')}</span>
        </th>
        {/*
        <th className="nk-tb-col tb-col-xl text-left">
          <span>{t('LockupPeriod')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl text-left">
          <span>{t('ConversionToOrdinary')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl text-left">
          <span>{t('ConversionRate')}</span>
        </th> */}

        <th className="nk-tb-col">
          <span />
        </th>
      </tr>
    </thead>
  );
};

export default HoldingClassTableHeader;
